export default "__VITE_ASSET__J0KMWPP6__"